import bbApi from "../../api"
import { downloadPdfFromApi } from "./downloadFile"

export async function handleLoanSummaryDownload(
  subscription_id: string,
  quote_id: string,
  filename?: string
) {
  try {
    const response = await bbApi.rateflow.generatePDF({
      subscription_id,
      quote_id
    })

    if (!response || "status" in response || !response.file) {
      return false
    }

    return await downloadPdfFromApi(
      { file: response.file },
      filename || "loan-summary.pdf"
    )
  } catch (e) {
    return false
  }
}
